import { ReadonlyRecord, IDictionary } from '@bimser/core';
import { Record, List, Map } from 'immutable';
import { IDelegation, Delegation, DelegationFactoryFromJS } from './IDelegation';
import {
	IDelegationFormData,
	DelegationFormData,
	DelegationFormDataFactory,
	DelegationFormDataFactoryFromJS
} from './IDelegationFormData';
import {
	IPermissionScope,
	PermissionScope,
	PermissionScopeFactory,
	PermissionScopeFactoryFromJS
} from './IPermissionScope';

interface IBaseDelegationState {}

export interface IDelegationState extends IBaseDelegationState {
	scopeData: IPermissionScope[];
	basicScopeData: IPermissionScope[];
	tokens: number[];
	data: IDictionary<IDelegation>;
	taken: number[];
	given: number[];
	form: IDelegationFormData;
	loading: boolean;
}

export interface IReadonlyDelegationState extends IBaseDelegationState {
	scopeData: List<PermissionScope>;
	basicScopeData: List<PermissionScope>;
	tokens: List<number>;
	data: Map<string, Delegation>;
	taken: List<number>;
	given: List<number>;
	form: DelegationFormData;
	loading: boolean;
}

export type DelegationState = ReadonlyRecord<IReadonlyDelegationState>;

export const DelegationStateFactory = Record<IReadonlyDelegationState>({
	taken: List(),
	given: List(),
	data: Map(),
	form: DelegationFormDataFactory(),
	scopeData: List(),
	basicScopeData: List(),
	tokens: List(),
	loading: false
});

export const DelegationStateFactoryFromJS = function (data: IDelegationState) {
	const _data: IDictionary<Delegation> = Object.keys(data.data).reduce(function (
		previous: IDictionary<Delegation>,
		current
	) {
		previous[current] = DelegationFactoryFromJS(data.data[current]);
		return previous;
	}, {});

	const _scopeData =
		data && data.scopeData ? data.scopeData.map(d => PermissionScopeFactoryFromJS(d)) : [];
	const _basicScopeData =
		data && data.basicScopeData
			? data.basicScopeData.map(d => PermissionScopeFactoryFromJS(d))
			: [];

	return DelegationStateFactory({
		data: Map(_data),
		taken: List(data.taken),
		given: List(data.given),
		form: DelegationFormDataFactoryFromJS(data.form),
		scopeData: List(_scopeData),
		basicScopeData: List(_basicScopeData),
		tokens: List(data.tokens),
		loading: data.loading
	});
};
